module.exports = __webpack_public_path__ + "img/eps.4835c1e3.svg";